// reportGeneratorSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  reportGeneratorFiles: []
};

const reportGeneratorSlice = createSlice({
  name: 'reportGenerator',
  initialState,
  reducers: {
    setReportGeneratorFiles: (state, action) => {
      state.reportGeneratorFiles = action.payload;
    },
  },
});

export const { setReportGeneratorFiles } = reportGeneratorSlice.actions;
export default reportGeneratorSlice.reducer;
